<template>
  <div v-if="item" class="stat-menu-item-category">
    <span
      class="stat-menu-item-category__item"
      v-for="(cat, key) in categories"
      :key="`cat-${cat.id}-${key}`"
    >
      {{ cat.name }}
    </span>
    <span
      class="stat-menu-item-category__item stat-menu-item-category__item_collection"
      v-for="(collection, key) in collections"
      :key="`collection-${collection.id}-${key}`"
    >
      {{ collection.name }}
    </span>
  </div>
</template>

<script>
  export default {
    name: 'MenuItemCategory',
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      categories () {
        return this?.item?.categories || []
      },
      collections () {
        return this?.item?.collections || []
      },

    },
  }
</script>

<style lang="less" scoped>
.stat-menu-item-category {
  display: inline-block;

  &__item {

    &:after {
      content: ' / ';
      display: inline;
      padding: 0 2px;
      color: #A8A8A8;
    }

    &_collection {
      color: #888686;
    }

    &:last-child {
      &:after {
        display: none;
      }
    }
  }
}
</style>
